import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/enhanced-integration.css';
import './styles/advanced-components.css';
import './styles/premium-transitions.css';
import './styles/edge-compatibility.css';
import './i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';

// En production, les messages de débogage ne s'affichent pas dans la console des visiteurs
// (les avertissements et les erreurs restent visibles).
if (process.env.NODE_ENV === 'production') {
  const silent = () => {};
  console.log = silent;
  console.debug = silent;
  console.info = silent;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
);

reportWebVitals();
